<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <div class="tagView">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="message">
        <p class="bold">尊敬的客户：</p>
        <p class="space">根据《国家税务总局北京市税务局关于开展全面数字化的电子发票试点工作的公告》(国家税务总局北京市税务局公告 2023 年第3号)以及主管税务机关的要求，北京联合信任技术服务有限公司（简称“我司”）于2024年4月24日开始开具的发票升级为全面数字化的电子发票（简称“数电发票”），同时将不再提供旧版电子（纸质）普票或纸质专票。</p>

        <p class="bold">关于数电发票作如下说明:</p>
        <p>
          1、数电发票版式全面简化，取消了发票密码区、发票代码、校验码、收款人、复核人、销售方。数电发票无联次，基本内容包括:发票号码、开票日期、购买方信息、销售方信息、项目名称、规格型号、单位、数量、单价、金额、税率/征收率、税额、合计、价税合计、备注、开票人等。</p>

        <p>2、数电发票的法律效力、基本用途等与旧版纸质发票相同。 </p>

        <p>3、数电发票可自行打印，无需在纸质打印件上加盖发票专用章。 </p>
        <p>4、数电发票不支持换开旧版的增值税电子（纸质）普票及纸质专票。 </p>

        <p>5、开票规则： </p>
        <p class="space">a、充值后，您可随时申请开具发票，可申请开票金额不超过实际支付金额；</p>
        <p class="space">b、如需申请重开发票，请到权利卫士app“我的-申请开票-开票历史”中申请重开；</p>
        <p>6、【信息准确性负责】请您在申请开票时，务必确保所有开票信息（特别是购买方名称、纳税人识别号）准确无误。因您填写信息错误导致的一切后果和责任，由您自行承担。</p>
        <p>7、【红冲权利】我司有权在发现开票信息错误、涉嫌虚假或违反法律法规时，为维护税务合规性，单方面对已开具的发票执行红冲（作废）操作。</p>
        <p>8、如申请发票遇到问题，请联系客服，客服微信二维码为： </p>
        <p style="text-align:center; margin-top:20px"><img src="https://evidence-public.oss-cn-beijing.aliyuncs.com/customerImages/1.png" alt="" width="131" height="131"></p>

        
      </div>
    </div>
  </el-row>
</template>

<script>
export default {
  name: "apply",
  data() {
    return {
      activeName: "first",
      isStretch: true,
      searchData: {},
    };
  },
  components: {},
};
</script>

<style scoped lang="less">
.message {
  margin: 20px 17px;
  p{
    color: #666666;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 32px;
    &:last-child{
      margin-top: 20px;
    }
    b{
      color: #6288FB;
      margin: 0 5px;
    }
  }
  .bold{
      color: #333;
      font-weight: bold;
  }
  .space{
    text-indent: 2em;
  }
}
</style>
